import {Component, Input, OnChanges, TemplateRef} from '@angular/core';
import {ProductQuery, SearchProductEntry} from '@services/resource/search-product-resources';
import {ProductEntryWidgetContext} from '@app/product-list/product-entry/product-entry-widget';
import {Params, RouterLink} from '@angular/router';
import {ProductGroupTranslate} from '@util/pipes/product-group-translate';
import {CommonModule} from '@angular/common';
import {MarkantElementsModule} from '@markant/elements-angular';

@Component({
  selector: 'app-product-entry',
  templateUrl: './product-entry.component.html',
  styleUrls: ['./product-entry.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, ProductGroupTranslate, MarkantElementsModule],
})
export class ProductEntryComponent implements OnChanges {
  @Input() entry: SearchProductEntry;
  @Input() query: ProductQuery;
  @Input() index?: number;
  @Input() entryWidget?: TemplateRef<ProductEntryWidgetContext>;

  widgetContext: ProductEntryWidgetContext;

  private imageFailed = false;

  ngOnChanges(): void {
    this.widgetContext = {entry: this.entry, query: this.query, index: this.index};
    this.imageFailed = false;
  }

  get detailLink(): unknown[] {
    return ['../product', this.entry.product.id];
  }

  get detailQueryParams(): Params {
    return {query: ProductQuery.uriEncode(this.query), index: this.index};
  }

  get coverImage(): string | undefined {
    if (this.imageFailed) {
      return undefined;
    }
    return this.entry.product.coverImageEntry || this.entry.product.coverImage;
  }

  get productName(): string {
    return this.entry.product.name || 'Produkt ohne Namen';
  }

  get startupName(): string {
    return this.entry.startup?.name || '';
  }

  onImageError(): void {
    this.imageFailed = true;
  }
}
